import { get, post } from "../request-manager";

/** ListCallbackConfigs - 查询本客户事件任务回调地址 */
export function getCallbackAddressList(): Promise<CallbackAddressType.ApiResponse<CallbackAddressType.CallbackAddressListRes>> {
  return get(`/v1alpha1/callbackConfigs`);
}

/** SaveCallbackAdmin - 保存地址管理员（推送账号） */
export function saveCallbackAdmin(params: CallbackAddressType.SaveAdminParam): Promise<CallbackAddressType.ApiResponse<CallbackAddressType.SaveAdminRes>> {
  return post(`/v1alpha1/callbackConfigs/admin`, params);
}

/** SaveCallbackConfig - 保存一种回调地址 */
export function saveCallbackAddress(params: CallbackAddressType.SaveCallbackParam): Promise<CallbackAddressType.ApiResponse<CallbackAddressType.SaveCallbackRes>> {
  return post(`/v1alpha1/callbackConfigs`, params);
}

/** ClearCallbackConfig - 清空事件或任务回调地址 */
export function clearCallbackAddress(params: CallbackAddressType.ClearCallbackParam): Promise<CallbackAddressType.ApiResponse<CallbackAddressType.ClearCallbackRes>> {
  return post(`/v1alpha1/callbackConfigs/clear`, params);
}

/** TestCallbackConfig - 测试回调地址 */
export function testCallbackAddress(params: CallbackAddressType.TestCallbackParam): Promise<CallbackAddressType.ApiResponse<CallbackAddressType.TestCallbackRes>> {
  return post(`/v1alpha1/callbackConfigs/test`, params);
}

/** ResetCallbackSecret - 重置一种回调 Secret */
export function resetCallbackSecret(params: CallbackAddressType.ResetCredentialParam): Promise<CallbackAddressType.ApiResponse<CallbackAddressType.ResetCredentialRes>> {
  return post(`/v1alpha1/callbackConfigs/resetSecret`, params);
}

/** ResetCallbackAppId - 重置一种回调 AppId */
export function resetCallbackAppId(params: CallbackAddressType.ResetCredentialParam): Promise<CallbackAddressType.ApiResponse<CallbackAddressType.ResetCredentialRes>> {
  return post(`/v1alpha1/callbackConfigs/resetAppId`, params);
}

/** ListDeveloperPersons - 本客户开发者账号下拉 */
export function getDeveloperAccounts(params: {
  page: number;
  pageSize: number;
  keyword?: string;
}): Promise<CallbackAddressType.ApiResponse<DeveloperAccountType.DeveloperAccountListRes>> {
  return post(`/v1alpha1/callbackConfigs/developers`, params);
}
